<template>
  <v-container
    :class="['shot-container', mobileLayout ? 'shot-container-mobile' : '']"
    v-resize="onResize"
  >
    <v-row wrap class="mb-6" justify="center" no-gutters>
      <div
        :class="['px-0 mx-0', isNexus || isNexusOffline ? 'nexus-container' : 'std-container']"
        ref="contentContainer"
      >
        <v-card
          :class="[
            'mx-0 px-0 pt-3 shot-card black--text',
            isNexus || isNexusOffline ? 'nexus-card' : 'std-card',
          ]"
          :width="cardWidth"
          outlined
          tile
        >
          <!-- <v-btn x-small icon absolute bottom left class="" @click.native="fetchData">
            <v-icon>mdi-cached</v-icon>
          </v-btn> -->
          <!-- <v-btn
            v-if="hasOtherPlayers"
            x-small
            icon
            absolute
            topo
            right
            class=""
            @click.native="hideOthers = !hideOthers"
          >
            <v-icon v-if="!hideOthers">visibility</v-icon>
            <v-icon v-if="hideOthers">visibility_off</v-icon>
          </v-btn> -->

          <v-col cols="12" sm="12" class="text-center player-section">
            <img class="logo" :src="E6Logo" />
          </v-col>

          <v-col cols="12" sm="12" class="text-center player-section">
            <div class="text-h4 text-uppercase font-weight-bold" v-if="isNexusOffline && pageData">
              {{ pageData.p | getPlayer }}
            </div>
            <div class="text-h4 text-uppercase font-weight-bold" v-else>
              {{ currentPlayerName || '...' }}
            </div>

            <v-card-subtitle
              class="text-subtitle-1 text-center py-0"
              v-if="isNexusOffline && pageData && pageData.courseData"
            >
              {{ pageData.courseData.name || '...' }}
            </v-card-subtitle>
            <v-card-subtitle class="text-subtitle-1 text-center py-0" v-else>
              {{ courseName || '...' }}
            </v-card-subtitle>

            <div
              class="text-subtitle-1 text-uppercase font-weight-bold"
              v-if="isNexusOffline && pageData"
            >
              {{
                pageData.h !== undefined || pageData.h !== null ? `Hole ${pageData.h + 1}` : `...`
              }}
            </div>
            <div class="text-subtitle-1 text-uppercase font-weight-bold" v-else>
              {{ holeIndex ? `Hole ${holeIndex}` : `...` }}
            </div>
          </v-col>

          <v-card
            class="topViewImage"
            :height="cardHeight"
            :width="cardWidth"
            outlined
            flat
            tile
            ref="imgCard"
          >
            <div class="progress" v-if="loading || checkNexus">
              <pulse-loader
                class="text-center"
                :color="loaderColor"
                :size="loaderSize"
              ></pulse-loader>
            </div>

            <v-btn
              v-if="hasOtherPlayers && !singlePlayer"
              x-small
              icon
              absolute
              bottom
              right
              class=""
              color="white"
              @click.native="hideOthers = !hideOthers"
              style="z-index: 99999; right: 50px"
            >
              <span v-if="!hideOthers">
                hide players
                <v-icon>visibility</v-icon>
              </span>
              <span v-if="hideOthers">
                show players
                <v-icon>visibility_off</v-icon>
              </span>
            </v-btn>

            <v-img
              v-if="!loading && !checkNexus"
              :width="cardWidth"
              :height="cardHeight"
              class="white--text align-end pa-0 ma-0"
              :aspect-ratio="isNexus ? '4/5' : '0.5'"
              :src="
                isNexus
                  ? LZTopViewImg
                  : isNexusOffline && pageData
                  ? pageData.topViewImageUrl
                  : topViewImg
              "
              :lazy-src="lazyTopViewImg"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <div v-show="!hideOthers">
              <canvas
                v-show="!loading && !checkNexus"
                :class="[
                  'topViewCanvas topViewCanvasOthers',
                  isNexus ? 'nexus-canvas' : 'std-canvas',
                ]"
                :width="cardWidth"
                :height="cardHeight"
                ref="topViewCanvasOthers"
              ></canvas>
            </div>

            <canvas
              v-show="!loading && !checkNexus"
              :class="['topViewCanvas', isNexus ? 'nexus-canvas' : 'std-canvas']"
              :width="cardWidth"
              :height="cardHeight"
              ref="topViewCanvas"
            ></canvas>
          </v-card>

          <v-col cols="12" sm="12" class="text-center black--text location-section py-5">
            <div class="text-h5 text-uppercase font-weight-regular">Ball Location</div>
            <div class="text-h4 text-uppercase font-weight-bold">
              <p class="mb-1 text-h" v-if="isNexusOffline && pageData">
                {{ pageData.t }}
              </p>
              <p class="mb-1 text-h" v-else-if="terrainType">
                {{ utility_terrainTypeFormat(terrainType) }}
              </p>
            </div>
          </v-col>

          <v-row wrap class="info-section" justify="center" no-gutters v-if="!isDrivingRange">
            <v-col class="text-center black--text font-weight-bold info-section py-6">
              <div
                class="text-h3 text-uppercase font-weight-bold"
                v-if="isNexusOffline && pageData"
              >
                {{ roundNumCeil(pageData.dtp / 3) | nan }}
              </div>
              <div class="text-h3 text-uppercase font-weight-bold" v-else>
                {{ pinDistance | nan }}
              </div>

              <div class="text-h5 text-uppercase font-weight-bold">yards</div>
              <div
                class="text-h6 font-weight-regular text-uppercase"
                v-if="isNexus || isNexusOffline"
              >
                to the green
              </div>
              <div class="text-h6 font-weight-regular text-uppercase" v-else>to the pin</div>
            </v-col>

            <div class="py-8" v-if="(isNexus || isNexusOffline) && LZDistanceToEdge">
              <v-divider vertical></v-divider>
            </div>

            <v-col
              v-if="(isNexus || isNexusOffline) && LZDistanceToEdge"
              class="text-center black--text font-weight-bold info-section py-6"
            >
              <div class="text-h3 text-uppercase font-weight-bold">
                <span v-if="isNexusOffline && pageData">
                  {{ Math.abs(roundNumCeil((pageData.ed * -1) / 3)) | nan }}
                </span>
                <span v-else-if="isNexus || LZDistanceToEdge">
                  {{ Math.abs(LZDistanceToEdge) | nan }}
                </span>
              </div>
              <div class="text-h5 text-uppercase font-weight-bold">yards</div>
              <div class="text-h6 font-weight-regular text-uppercase">from edge</div>
            </v-col>
          </v-row>

          <v-col cols="12" sm="12" class="text-center white--text carry-section py-5">
            <div class="text-h5 text-uppercase font-weight-regular" v-if="isNexusOffline">
              Last Shot Distance
            </div>
            <div class="text-h5 text-uppercase font-weight-regular" v-else>Total Distance</div>

            <div
              class="text-h2 text-uppercase font-weight-black py-0"
              v-if="isNexusOffline && pageData"
            >
              {{ roundNumCeil(pageData.d / 3) | nan }}
            </div>
            <div class="text-h2 text-uppercase font-weight-black py-0" v-else>
              {{ totalDistance | nan }}
            </div>
            <div class="text-h5 text-uppercase font-weight-bold">
              <span class="font-weight-regular">yards</span>
            </div>
          </v-col>
        </v-card>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import groupBy from 'lodash/groupBy';
import utilityMixin from '@/mixins/utilityMixin';
import E6Logo from '@/assets/E6_Cube.png';
import { courseData } from '@/lib/nexusCourseData';
import { drawPoint, drawEdgePoint } from '@/utils/canvasHelpers'; //* Other functions available

export default {
  name: 'Shotview',
  mixins: [utilityMixin],

  props: {
    shotIDProp: {
      type: String,
    },
    singlePlayer: {
      type: Boolean,
      default: false,
    },
    mobileLayout: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      E6Logo,
      pageData: null,
      loading: false,
      checkNexus: false,
      shotDataRes: [],
      canvas: null,
      ctx: null,

      canvasOthers: null,
      ctxOthers: null,
      hideOthers: false,
      hasOtherPlayers: false,

      canvasWidth: null,
      canvasHeight: null,
      isMobile: false,
      loaderColor: '#BA2127',
      loaderSize: '1em',
      isNexusOffline: false,
      courseData: null,
      groupedOtherPlayers: {},
      lazyTopViewImg:
        'https://e6golf-qa-assets.imgix.net/uploads/courses/cae56405-286f-431d-8632-e2ce95facc42/145/bethpage_black_4_topview.jpg?blur=100&ar=1.33&w=265',
      lazyCourseImg:
        'https://e6golf-qa-assets.imgix.net/uploads/courses/84f6dbef-c8f9-4dba-849c-5e0b4afc1aa9/107/aviara_0_splash.jpg?blur=100&ar=0.5w=414&h=206',
    };
  },

  // beforeCreate() {
  created() {
    // http://localhost:8080/svd/%7B%22p%22%3A%220%22%2C%22c%22%3A%22qr%22%2C%22cv%22%3A130%2C%22h%22%3A9%2C%22t%22%3A%22Fairway%22%2C%22d%22%3A705.61%2C%22dtp%22%3A202.3%2C%22bx%22%3A0.46%2C%22by%22%3A0.67%2C%22ex%22%3A0.42%2C%22ey%22%3A0.67%2C%22ed%22%3A-18%2C%22px%22%3A0.53%2C%22py%22%3A0.36%7D
    // const data = {
    //   p: '0', // player index
    //   c: 'qr', // course code to pull from static list
    //   cv: 130, // course version for image url build
    //   h: 9, // hole number
    //   t: 'Fairway', // ball position
    //   d: 705.61, // total distance
    //   dtp: 202.3, // distance to pin/green
    //   bx: 0.46, // ball x pos
    //   by: 0.67, // ball y pos
    //   ex: 0.42, // edge x pos
    //   ey: 0.67, // edge y pos
    //   ed: -18, // distance from edge
    //   px: 0.53, // pin x pos
    //   py: 0.36, // pin y pos
    // };
    // const newLog = encodeURIComponent(JSON.stringify(data));
    // console.log('newLog:', newLog);

    console.log(this.$route);
    window.addEventListener('touchend', this.onScroll);
    // window.addEventListener('scroll', this.onScroll);

    if (this.$route?.params?.data) {
      // /svd/%7B%22p%22:0,%22c%22:%22qr%22,%22cv%22:134,%22h%22:0,%22t%22:%22Fairway%22,%22d%22:664.75,%22dtp%22:385.25,%22bx%22:0.51,%22by%22:0.74,%22ex%22:0.56,%22ey%22:0.74,%22ed%22:27,%22px%22:0.50,%22py%22:0.16%7D
      this.loading = true;
      this.isNexusOffline = true;
      this.pageData = this.$route?.params?.data ? JSON.parse(this.$route.params.data) : null;
      // console.log('this.pageData:', this.pageData);
    } else {
      this.fetchData();
    }
  },

  destroyed() {
    window.removeEventListener('touchend', this.onScroll);
    // window.removeEventListener('scroll', this.onScroll);
  },

  mounted() {
    try {
      if (this.pageData && this.isNexusOffline) {
        let { c } = this.pageData;
        if (!c) {
          c = 'qr'; //* default to quarry ridge to prevent empty data
          this.pageData.c = 'qr'; //* default to quarry ridge to prevent empty data
        }
        for (let i = 0, l = courseData.courses.length; i < l; i++) {
          const obj = courseData.courses[i];
          if (this.pageData?.c?.includes(obj.key)) {
            // console.log('company', obj);
            this.courseData = obj;
            this.pageData.courseData = obj;
            this.pageData.topViewImageUrl = this.getTopViewUrl();
          }
        }
        this.offlineCanvasDrawBallLocation(this.pageData);
        this.loading = false;
      }
    } catch (error) {
      console.log('error:', error);
      this.$root.vtoast.show({
        text: `Error loading shot data`,
        color: 'error',
      });
    }
    //* 6bd55ac3-0a00-4d4e-b9ca-504dd98b131a
    //* round f7c4dfc9-a6c0-4440-8edf-7c9a8f818563 Guests (4)
    //* shot 15bb357c-067c-4c4a-b986-4acc85d21a07 Guest.1

    //* round aaa3e949-6993-4f4a-9c51-507bfb3e49cd Guests (2)
    //* Guest 1 multiple shots
    //* shot 1: 8163f86f-9f87-4e45-be45-0ed28500a314
    //* shot 2: a896129e-7e27-4845-ab79-d39bf0a76107
    //* Guest 2 multiple shots

    //* Round 15481058-416c-4b48-8495-db1fb39884d4
    //* CL Test and Guest
    //* User shot 1 571b260a-c4c4-444a-9f27-62ebc003ed32
    //* Guest shot 1 4703416e-f889-4a4a-8caf-3d69a53cf985

    try {
      const interval = setInterval(() => {
        if (this.mobileLayout) {
          clearInterval(interval);
          return;
        }

        if (this.$refs?.imgCard && !this.checkNexus) {
          this.canvasWidth = parseInt(this.$refs?.imgCard?.styles?.width);
          this.canvasHeight = parseInt(this.$refs?.imgCard?.styles?.height);
          clearInterval(interval);
        }
      }, 50);
    } catch (error) {
      console.error('error:', error);
    }
  },

  computed: {
    ...mapGetters({
      shotData: 'shots/shotData',
    }),

    cardWidth() {
      this.onResize();
      if ((this.isMobile || this.mobileLayout) && this.isNexus) {
        return '360';
      }
      if (this.mobileLayout) {
        return '331';
      }
      if (this.isNexusOffline && !this.isMobile) {
        return '612';
      }
      if (this.isNexusOffline && this.isMobile) {
        return '360';
      }
      return this.mobileLayout || !this.isNexus ? '331' : '612';
    },

    cardHeight() {
      this.onResize();
      if ((this.isMobile || this.mobileLayout) && this.isNexus) {
        return '450';
      }
      if (this.mobileLayout) {
        return '663';
      }
      if (this.isNexusOffline && !this.isMobile) {
        return '765';
      }
      if (this.isNexusOffline && this.isMobile) {
        return '450';
      }
      return this.isNexus ? '765' : '663';
    },

    currentPlayerShotData() {
      const { shotID } = this.$route.params;
      const newShotID = shotID ?? this.shotIDProp;
      const player = this.shotData?.find((data) => {
        return data.shot_id === newShotID;
      });
      // console.log('player:', player);
      return player;
    },

    filteredShotData() {
      if (this.shotData) {
        const currentHoleData = this.shotData?.filter((shot) => {
          return shot?.course_hole_index === this.currentPlayerShotData?.course_hole_index;
        });
        // console.log('currentHoleData:', currentHoleData);
        return currentHoleData;
      }
    },

    otherPlayers() {
      const grouped = this.getGroupedPlayers();
      this.groupedOtherPlayers = grouped;
      return grouped;
    },

    currentPlayerName() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { display_name: playerName } = this.currentPlayerShotData;
        return playerName ?? 'N/A';
      }
    },

    topViewImg() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { course_hole_image_url: topViewImageUrl } = this.currentPlayerShotData;
        return `${topViewImageUrl ? `${topViewImageUrl}?w=530&ar=1:2&fit=fill` : ''}`;
      }
    },

    courseImg() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { course_image_url: courseImageUrl } = this.currentPlayerShotData;
        return courseImageUrl ?? '';
      }
    },

    courseName() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { course_name: courseName } = this.currentPlayerShotData;
        return courseName ?? 'N/A';
      }
    },

    holeIndex() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { course_hole_index: holeIndex } = this.currentPlayerShotData;
        return !isNaN(holeIndex) ? holeIndex + 1 : '...';
      }
    },

    pinDistance() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { pin_distance: pinDistance = 0 } = this.currentPlayerShotData;
        const formattedPinDistance = this.roundNumCeil(pinDistance / 3);

        return !isNaN(formattedPinDistance) ? formattedPinDistance : '...';
      }
    },

    pinElevation() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { pin_elevation: pinElevation = 0 } = this.currentPlayerShotData;
        const formattedPinElevation = this.roundNum(pinElevation);

        return !isNaN(formattedPinElevation) ? formattedPinElevation : '...';
      }
    },

    carryDistance() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { total_carry: carry = 0 } = this.currentPlayerShotData;
        const formattedCarry = this.roundNumCeil(carry / 3);
        return !isNaN(formattedCarry) ? formattedCarry : '...';
      }
    },

    totalDistance() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { total_distance: total = 0 } = this.currentPlayerShotData;
        const formattedTotal = this.roundNumCeil(total / 3);
        return !isNaN(formattedTotal) ? formattedTotal : '...';
      }
    },

    ballPosX() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { ball_position_x: ballX } = this.currentPlayerShotData;
        return ballX ?? 0;
      }
    },

    ballPosY() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { ball_position_y: ballY } = this.currentPlayerShotData;
        return ballY ?? 0;
      }
    },

    teePosX() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { tee_position_x: teeX } = this.currentPlayerShotData;
        return teeX ?? 0;
      }
    },

    teePosY() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { tee_position_y: teeY } = this.currentPlayerShotData;
        return teeY ?? 0;
      }
    },

    pinPosX() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { pin_position_x: pinX } = this.currentPlayerShotData;
        return pinX ?? 0;
      }
    },

    pinPosY() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { pin_position_y: pinY } = this.currentPlayerShotData;
        return pinY ?? 0;
      }
    },

    playerTee() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { tee_level: teeLevel } = this.currentPlayerShotData;
        return teeLevel ?? 'TEE';
      }
    },

    playerColor() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { color } = this.currentPlayerShotData;
        return `${!color ? 'yellow' : `#${color}`}`;
      }
    },

    teeShot() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { started_on_tee: startedOnTee } = this.currentPlayerShotData;
        return startedOnTee ?? false;
      }
    },

    gameMode() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { game_mode: gameMode } = this.currentPlayerShotData;
        return gameMode ?? '';
      }
    },

    isDrivingRange() {
      return this.gameMode === 'practice_driving_range';
    },

    terrainType() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { terrain_type_key: terrainType } = this.currentPlayerShotData;
        return terrainType ?? '';
      }
    },

    //* Landing Zone Specifics
    isNexus() {
      //* Disabling nexus mode temporarily
      // return false;
      return this.gameMode === 'minigame_nexusgolf' && this.LZTopViewImg !== '';
    },

    LZTopViewImg() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { lz_top_view_image_url: LZTopViewImageUrl } = this.currentPlayerShotData;
        //* Disabling nexus mode temporarily
        // return '';

        return `${LZTopViewImageUrl ? `${LZTopViewImageUrl}?w=1024&ar=4:5&fit=fill` : ''}`;
        // return 'https://e6golf-qa-assets.imgix.net/uploads/courses/018ef01e-8d79-4fef-9532-3b45e2fbf6a6/125/quarry_ridge_0_landingzone.jpg?w=1024&ar=4:5&fit=fill';
      }
    },

    LZBallPosX() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { lz_position_x: lzBallX } = this.currentPlayerShotData;
        return lzBallX ?? 0;
      }
    },

    LZBallPosY() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { lz_position_y: lzBallY } = this.currentPlayerShotData;
        return lzBallY ?? 0;
      }
    },

    LZPinPosX() {
      // landingzonepos="0.499328 0.227206" hole 1
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { lz_top_view_position_x: lzPinX } = this.currentPlayerShotData;
        return lzPinX ?? 0;
        // return 0.499328; //* temp hole one lz pin for testing
      }
    },

    LZPinPosY() {
      // landingzonepos="0.499328 0.227206" hole 1
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { lz_top_view_position_y: lzPinY } = this.currentPlayerShotData;
        return lzPinY ?? 0;
        // return 0.227206; //* temp hole one lz pin for testing
      }
    },

    LZCenterPinPosX() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { lz_center_position_x: lzCenterPinX } = this.currentPlayerShotData;
        return lzCenterPinX ?? 0;
      }
    },

    LZCenterPinPosY() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { lz_center_position_y: lzCenterPinY } = this.currentPlayerShotData;
        return lzCenterPinY ?? 0;
      }
    },

    LZEdgeX() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { lz_edge_position_x: lzEdgePosX } = this.currentPlayerShotData;
        return lzEdgePosX ?? 0;
      }
    },

    LZEdgeY() {
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { lz_edge_position_y: lzEdgePosY } = this.currentPlayerShotData;
        return lzEdgePosY ?? 0;
      }
    },

    LZDistanceToEdge() {
      let formattedEdgeDist = 0;
      if (this.utility_isObject(this.currentPlayerShotData)) {
        const { lz_x_dist_to_edge: lzEdgeDist } = this.currentPlayerShotData;
        formattedEdgeDist = this.roundNumCeil(Math.abs(lzEdgeDist) / 3);
        return formattedEdgeDist ?? 0;
      }
      if (this.pageData?.ed) {
        const { ed: lzEdgeDist } = this.pageData;
        formattedEdgeDist = this.roundNumCeil(Math.abs(lzEdgeDist) / 3);
        return formattedEdgeDist ?? 0;
      }
    },
  },

  methods: {
    fetchData() {
      this.loading = true;
      this.checkNexus = true;
      const { shotID } = this.$route?.params;
      const newShotID = shotID ?? this.shotIDProp;
      console.log('newShotID:', newShotID);

      if (!newShotID) {
        this.$root.vtoast.show({
          text: `Error retrieving shot details`,
          color: 'error',
        });
        return;
      }

      try {
        this.$store.dispatch('shots/shotview', newShotID).then((res) => {
          // console.log('res:', res);
          if (!res) {
            //* show error
            this.$root.vtoast.show({
              text: `Error retrieving shot details`,
              color: 'error',
            });
          }
          this.canvasDrawBallLocation();
          this.shotDataRes = res;
          this.loading = false;
          setTimeout(() => {
            this.checkNexus = false;
          }, 500);
        });
      } catch (error) {
        console.error('error:', error);
        this.loading = false;
        this.$root.vtoast.show({
          text: `Error retrieving shot details`,
          color: 'error',
        });
      }
    },

    onResize() {
      if (window.innerWidth < 601) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }

      this.canvasWidth = parseInt(this.$refs?.imgCard?.styles?.width);
      this.canvasHeight = parseInt(this.$refs?.imgCard?.styles?.height);
    },

    onScroll() {
      this.updatedFetchDataDraw();
    },

    updatedFetchDataDraw() {
      //* cancel pending call
      clearTimeout(this._timerId);

      if (this.pageData && this.isNexusOffline) {
        //* delay new call 500ms
        this._timerId = setTimeout(() => {
          this.ctx?.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
          if (this.pageData) {
            this.offlineCanvasDrawBallLocation(this.pageData);
            return;
          }
          this.pageData = this.$route?.params?.data ? JSON.parse(this.$route.params.data) : null;
          this.offlineCanvasDrawBallLocation(this.pageData);
        }, 500);
        return;
      }

      //* delay new call 500ms
      this._timerId = setTimeout(() => {
        this.ctx?.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
        this.groupedOtherPlayers = this.getGroupedPlayers();
        if (this.shotData?.length) {
          this.canvasDrawBallLocation();
          return;
        }
        this.fetchData();
      }, 500);
    },

    roundNum(num) {
      if (!num && num !== 0) return;
      return num.toFixed(1);
    },

    roundNumCeil(num) {
      if (!num && num !== 0) return;
      return Math.ceil(num.toFixed(1));
    },

    getTeeColor() {
      let teeColor = '';
      switch (this.playerTee) {
        case 'Black':
          teeColor = '#222';
          break;
        case 'Blue':
          teeColor = '#0000ff';
          break;
        case 'Red':
          teeColor = '#BA2127';
          break;
        case 'Yellow':
          teeColor = '#ffcc00';
          break;
        case 'White':
          teeColor = '#FFF';
          break;
        default:
          teeColor = '#FFF';
          break;
      }

      return teeColor;
    },

    getEdgeOffsetX(data) {
      let isPositive = false;
      let terrain = '';
      if (data && this.isNexusOffline) {
        isPositive = Math.sign(data.ed) >= 0;
        terrain = data.t;
      } else {
        isPositive = Math.sign(this.LZDistanceToEdge) >= 0;
        terrain = this.terrainType;
      }

      let offsetAdjust = 0;
      if ((terrain === 'kTerrainFairway' || terrain === 'Fairway') && isPositive) {
        offsetAdjust = 0;
      } else if ((terrain === 'kTerrainFairway' || terrain === 'Fairway') && !isPositive) {
        offsetAdjust = 10;
      } else if ((terrain !== 'kTerrainFairway' || terrain !== 'Fairway') && isPositive) {
        offsetAdjust = 0;
      } else if ((terrain !== 'kTerrainFairway' || terrain !== 'Fairway') && !isPositive) {
        offsetAdjust = 10;
      }
      return offsetAdjust;
    },

    canvasDrawBallLocation() {
      try {
        this.canvas = this.$refs?.topViewCanvas;
        this.ctx = this.canvas?.getContext('2d');
        this.ctx?.clearRect(0, 0, this.canvasWidth, this.canvasHeight);

        let ballX = 0;
        let ballY = 0;
        let pinX = 0;
        let pinY = 0;

        if (this.isNexus) {
          this.canvasWidth = parseInt(this.$refs?.imgCard?.styles.width);
          this.canvasHeight = parseInt(this.$refs?.imgCard?.styles.height);

          ballX = this.LZBallPosX;
          ballY = this.LZBallPosY;
          pinX =
            this.LZCenterPinPosX !== 0 && this.LZPinPosX !== 0
              ? this.LZCenterPinPosX
              : this.LZPinPosX !== 0
              ? this.LZPinPosX
              : this.pinPosX;
          pinY =
            this.LZCenterPinPosY !== 0 && this.LZPinPosY !== 0
              ? this.LZCenterPinPosY
              : this.LZPinPosY !== 0
              ? this.LZPinPosY
              : this.pinPosY;
        } else {
          ballX = this.ballPosX;
          ballY = this.ballPosY;
          pinX = this.pinPosX;
          pinY = this.pinPosY;
        }

        //* 0, 0 = top left std top view
        //* 330, 0 = top right std top view
        //* 0, 0 = top left std top view

        //* 0, 0 = top left lz top view
        //* 0, 765 = bottom left lz top view
        //* 612, 0 = top right lz top view
        //* 612, 765 = bottom right lz top view

        //* Ball Positions
        const ballXCoord = ballX * this.canvasWidth;
        const ballYCoord = ballY * this.canvasHeight;

        //* Pin Positions
        const pinXCoord = pinX * this.canvasWidth;
        const pinYCoord = pinY * this.canvasHeight;

        //* Tee Positions
        const teeXCoord = this.teePosX * this.canvasWidth;
        const teeYCoord = this.teePosY * this.canvasHeight;

        //* Edge Positions
        const edgeXCoord = this.LZEdgeX * this.canvasWidth;
        const edgeYCoord = this.LZEdgeY * this.canvasHeight;

        //* Get tee color for drawing tee box
        const teeColor = this.getTeeColor(this.playerTee);

        //* Draw current player tee position square with label
        // drawPointRect(this.ctx, teeXCoord, teeYCoord, this.playerTee, teeColor, 15);

        //* Draw current player tee position dot with NO label
        if (this.teeShot && !this.isNexus) {
          const teePayload = {
            canvas: this.canvas, // canvas
            context: this.ctx, // context
            x: teeXCoord, // x
            y: teeYCoord, // y
            label: null, // label
            color: teeColor, // color
            size: 8, // size
            offsetX: null, // offsetX
            offsetY: null, // offsetY
            labelSize: null, // labelSize
            drawLine: false, // drawLine
            pinDistance: null, // pinDistance
            pinX: null, // pinX
            pinY: null, // pinY
            isPoint: true, // isPoint
            drawTeeToBall: false, // drawTeeToBall
            teeX: null, // teeX
            teeY: null, // teeY
            teeShot: this.teeShot, // teeShot
          };
          drawPoint(teePayload);

          //* Old ind params - TODO remove
          // drawPoint(
          //   this.canvas, // canvas
          //   this.ctx, // context
          //   teeXCoord, // x
          //   teeYCoord, // y
          //   null, // label
          //   teeColor, // color
          //   8, // size
          //   null, // offsetX
          //   null, // offsetY
          //   null, // labelSize
          //   false, // drawLine
          //   null, // pinDistance
          //   null, // pinX
          //   null, // pinY
          //   true, // isPoint
          //   false, // drawTeeToBall
          //   null, // teeX
          //   null, // teeY
          //   this.teeShot // teeShot
          // );
        }

        //* Draw current player ball position
        // drawPoint(this.ctx, 30, 30, 'A', 'yellow', 5);
        // drawPoint(this.ctx, ballXCoord, ballYCoord, 'A', 'yellow', 5);
        // drawPoint(this.ctx, ballXCoord, ballYCoord, '📍', 'yellow', 4);
        const ballPayload = {
          canvas: this.canvas, // canvas
          context: this.ctx, // context
          x: ballXCoord, // x
          y: ballYCoord, // y
          label: this.isNexus || this.isDrivingRange ? '' : '⭐', // label
          color: this.playerColor, // color
          size: 7, // size
          offsetX: null, // offsetX
          offsetY: null, // offsetY
          labelSize: null, // labelSize
          drawLine: !this.isDrivingRange, // drawLine
          pinDistance: this.pinDistance, // pinDistance
          pinX: pinXCoord, // pinX
          pinY: pinYCoord, // pinY
          isPoint: true, // isPoint
          drawTeeToBall: !this.isNexus, // drawTeeToBall
          teeX: teeXCoord, // teeX
          teeY: teeYCoord, // teeY
          teeShot: this.teeShot, // teeShot
        };
        drawPoint(ballPayload);

        //* Old ind params - TODO remove
        // drawPoint(
        //   this.canvas, // canvas
        //   this.ctx, // context
        //   ballXCoord, // x
        //   ballYCoord, // y
        //   this.isNexus || this.isDrivingRange ? '' : '⭐', // label
        //   this.playerColor, // color
        //   7, // size
        //   null, // offsetX
        //   null, // offsetY
        //   null, // labelSize
        //   !this.isDrivingRange, // drawLine
        //   this.pinDistance, // pinDistance
        //   pinXCoord, // pinX
        //   pinYCoord, // pinY
        //   true, // isPoint
        //   // true, // drawTeeToBall
        //   !this.isNexus, // drawTeeToBall
        //   teeXCoord, // teeX
        //   teeYCoord, // teeY
        //   this.teeShot // teeShot
        // );

        if (this.isNexus && Math.abs(this.LZDistanceToEdge) > 4) {
          const offsetAdjust = this.getEdgeOffsetX();

          //* draw edge point
          const edgePayload = {
            canvas: this.canvas, // canvas
            context: this.ctx, // context
            x: ballXCoord, // x
            y: ballYCoord, // y
            label: `${Math.abs(this.LZDistanceToEdge)}yds`, // label
            color: 'white', // color
            size: 4, // size
            offsetX: offsetAdjust, // offsetX
            offsetY: null, // offsetY
            labelSize: null, // labelSize
            isPoint: true, // isPoint
            edgeX: edgeXCoord, // edgeX
            edgeY: edgeYCoord, // edgeY
          };
          drawEdgePoint(edgePayload);
        }

        //* Draw pin position
        // drawPoint(this.ctx, pinXCoord, pinYCoord, '📍', 'white', 4);
        // drawPoint(this.ctx, pinXCoord, pinYCoord, '⛳', 'white', 4);
        // drawPoint(this.ctx, pinXCoord, pinYCoord, 'Pin', 'white', 4);
        if (!this.isDrivingRange) {
          const pinPayload = {
            canvas: this.canvas, // canvas
            context: this.ctx, // context
            x: pinXCoord, // x
            y: pinYCoord, // y
            label: this.isNexus || this.isNexusOffline ? '' : '\u2691', // label
            color: 'white', // color
            size: 4, // size
            offsetX: 5, // offsetX
            offsetY: null, // offsetY
            labelSize: 18, // labelSize
            drawLine: false, // drawLine
            pinDistance: null, // pinDistance
            pinX: null, // pinX
            pinY: null, // pinY
            isPoint: true, // isPoint
            drawTeeToBall: false, // drawTeeToBall
            teeX: null, // teeX
            teeY: null, // teeY
            teeShot: this.teeShot, // teeShot
          };
          drawPoint(pinPayload);

          //* Old ind params - TODO remove
          // drawPoint(
          //   this.canvas, // canvas
          //   this.ctx, // context
          //   pinXCoord, // x
          //   pinYCoord, // y
          //   '\u2691', // label
          //   'white', // color
          //   4, // size
          //   5, // offsetX
          //   null, // offsetY
          //   18, // labelSize
          //   false, // drawLine
          //   null, // pinDistance
          //   null, // pinX
          //   null, // pinY
          //   true, // isPoint
          //   false, // drawTeeToBall
          //   null, // teeX
          //   null, // teeY
          //   this.teeShot // teeShot
          // );
        }
      } catch (error) {
        console.error('error:', error);
        this.loading = false;
        this.$root.vtoast.show({
          text: `Error drawing ball location`,
          color: 'error',
        });
      }
    },

    offlineCanvasDrawBallLocation(data) {
      // console.log('data:', data);
      this.canvas = this.$refs?.topViewCanvas;
      this.ctx = this.canvas?.getContext('2d');
      this.ctx?.clearRect(0, 0, this.canvasWidth, this.canvasHeight);

      let ballX = 0;
      let ballY = 0;
      let pinX = 0;
      let pinY = 0;

      this.canvasWidth = parseInt(this.$refs?.imgCard?.styles.width);
      this.canvasHeight = parseInt(this.$refs?.imgCard?.styles.height);

      ballX = data.bx;
      ballY = data.by;
      pinX = data.px;
      pinY = data.py;

      //* 0, 0 = top left std top view
      //* 330, 0 = top right std top view
      //* 0, 0 = top left std top view

      //* 0, 0 = top left lz top view
      //* 0, 765 = bottom left lz top view
      //* 612, 0 = top right lz top view
      //* 612, 765 = bottom right lz top view

      //* Ball Positions
      const ballXCoord = ballX * this.canvasWidth;
      const ballYCoord = ballY * this.canvasHeight;

      //* Pin Positions
      const pinXCoord = pinX * this.canvasWidth;
      const pinYCoord = pinY * this.canvasHeight;

      //* Edge Positions
      const edgeXCoord = data.ex * this.canvasWidth;
      const edgeYCoord = data.ey * this.canvasHeight;

      //* get correct player color
      let playerColor = '#ba2217';
      switch (this.pageData?.p) {
        case '0':
          playerColor = '#ba2127';
          break;
        case '1':
          playerColor = '#356dc0';
          break;
        case '2':
          playerColor = '#FFCC00';
          break;
        case '3':
          playerColor = '#35C09B';
          break;
        default:
          break;
      }

      //* Draw current player ball position
      const ballPayload = {
        canvas: this.canvas, // canvas
        context: this.ctx, // context
        x: ballXCoord, // x
        y: ballYCoord, // y
        label: '', // label
        color: playerColor, // color
        size: 7, // size
        offsetX: null, // offsetX
        offsetY: null, // offsetY
        labelSize: null, // labelSize
        drawLine: true, // drawLine
        pinDistance: this.roundNumCeil(data.dtp / 3), // pinDistance
        pinX: pinXCoord, // pinX
        pinY: pinYCoord, // pinY
        isPoint: true, // isPoint
        drawTeeToBall: false, // drawTeeToBall
        teeX: null, // teeX
        teeY: null, // teeY
        teeShot: false, // teeShot
      };
      drawPoint(ballPayload);

      //* Old ind params - TODO remove
      // drawPoint(
      //   this.canvas, // canvas
      //   this.ctx, // context
      //   ballXCoord, // x
      //   ballYCoord, // y
      //   '', // label
      //   playerColor, // color - get this color
      //   7, // size
      //   null, // offsetX
      //   null, // offsetY
      //   null, // labelSize
      //   true, // drawLine
      //   data.dtp, // pinDistance
      //   pinXCoord, // pinX
      //   pinYCoord, // pinY
      //   true, // isPoint
      //   // true, // drawTeeToBall
      //   false, // drawTeeToBall
      //   null, // teeX
      //   null, // teeY
      //   false // teeShot
      // );

      const offsetAdjust = this.getEdgeOffsetX(this.pageData);

      //* draw edge point
      const edgePayload = {
        canvas: this.canvas, // canvas
        context: this.ctx, // context
        x: ballXCoord, // x
        y: ballYCoord, // y
        label: `${Math.abs(this.roundNumCeil(data.ed / 3))}yds`, // label
        color: 'white', // color
        size: 4, // size
        offsetX: offsetAdjust, // offsetX
        offsetY: null, // offsetY
        labelSize: null, // labelSize
        isPoint: true, // isPoint
        edgeX: edgeXCoord, // edgeX
        edgeY: edgeYCoord, // edgeY
      };
      drawEdgePoint(edgePayload);

      //* Draw pin position
      const pinPayload = {
        canvas: this.canvas, // canvas
        context: this.ctx, // context
        x: pinXCoord, // x
        y: pinYCoord, // y
        label: this.isNexus || this.isNexusOffline ? '' : '\u2691', // label
        color: 'white', // color
        size: 4, // size
        offsetX: 5, // offsetX
        offsetY: null, // offsetY
        labelSize: 18, // labelSize
        drawLine: false, // drawLine
        pinDistance: null, // pinDistance
        pinX: null, // pinX
        pinY: null, // pinY
        isPoint: true, // isPoint
        drawTeeToBall: false, // drawTeeToBall
        teeX: null, // teeX
        teeY: null, // teeY
        teeShot: false, // teeShot
      };
      drawPoint(pinPayload);

      //* Old ind params - TODO remove
      // drawPoint(
      //   this.canvas, // canvas
      //   this.ctx, // context
      //   pinXCoord, // x
      //   pinYCoord, // y
      //   '\u2691', // label
      //   'white', // color
      //   4, // size
      //   5, // offsetX
      //   null, // offsetY
      //   18, // labelSize
      //   false, // drawLine
      //   null, // pinDistance
      //   null, // pinX
      //   null, // pinY
      //   true, // isPoint
      //   false, // drawTeeToBall
      //   null, // teeX
      //   null, // teeY
      //   false // teeShot
      // );
    },

    getGroupedPlayers() {
      const { shotID } = this.$route.params;
      const newShotID = shotID ?? this.shotIDProp;
      let isGuest = false;
      const players = this.filteredShotData?.filter((data) => {
        return (
          data.shot_id !== newShotID &&
          (data.user_id !== this.currentPlayerShotData.user_id ||
            data.guest_id !== this.currentPlayerShotData.guest_id)
        );
      });

      if (players?.length) {
        this.hasOtherPlayers = true;
      } else {
        this.hasOtherPlayers = false;
      }

      for (let i = 0; i < players?.length; i++) {
        if (players[i].guest_id) {
          isGuest = true;
        } else {
          isGuest = false;
        }
      }

      const grouped = groupBy(players, `${isGuest ? 'guest_id' : 'user_id'}`);
      return grouped;
    },

    drawOtherPlayers(newValueData) {
      for (const data in newValueData) {
        if (data) {
          this.canvasOthers = this.$refs?.topViewCanvasOthers;
          this.ctxOthers = this.canvasOthers?.getContext('2d');
          setTimeout(() => {
            const playerHole = newValueData[data]?.[0];
            const {
              display_name: name = 'Player',
              ball_position_x: ballX,
              ball_position_y: ballY,
              lz_position_x: LZBallX,
              lz_position_y: LZBallY,
              color = 'white',
            } = playerHole;
            const ballXCoord = ballX * this.canvas?.width;
            const ballYCoord = ballY * this.canvas?.height;
            if (this.isNexus) {
              const LZballXCoord = LZBallX * this.canvas?.width;
              const LZballYCoord = LZBallY * this.canvas?.height;

              const nexusBallPayload = {
                canvas: this.canvasOthers, // canvas
                context: this.ctxOthers, // context
                x: LZballXCoord, // x
                y: LZballYCoord, // y
                label: name, // label
                color: `#${color}` ?? 'white', // color
                size: 5, // size
                offsetX: 30, // offsetX
                offsetY: 10, // offsetY
                labelSize: '10', // labelSize
                drawLine: null, // drawLine
                pinDistance: null, // pinDistance
                pinX: null, // pinX
                pinY: null, // pinY
                isPoint: true, // isPoint
                drawTeeToBall: false, // drawTeeToBall
                teeX: null, // teeX
                teeY: null, // teeY
                teeShot: null, // teeShot
              };
              drawPoint(nexusBallPayload);
              return;
            }

            const otherBallPayload = {
              canvas: this.canvasOthers, // canvas
              context: this.ctxOthers, // context
              x: ballXCoord, // x
              y: ballYCoord, // y
              label: name, // label
              color: `#${color}` ?? 'white', // color
              size: 5, // size
              offsetX: 30, // offsetX
              offsetY: 10, // offsetY
              labelSize: '10', // labelSize
              drawLine: null, // drawLine
              pinDistance: null, // pinDistance
              pinX: null, // pinX
              pinY: null, // pinY
              isPoint: true, // isPoint
              drawTeeToBall: false, // drawTeeToBall
              teeX: null, // teeX
              teeY: null, // teeY
              teeShot: null, // teeShot
            };
            drawPoint(otherBallPayload);
          }, 100);
        }
      }
    },

    getTopViewUrl() {
      if (this.pageData) {
        const { courseData, cv, h } = this.pageData;
        return `${courseData.host}uploads/courses/${courseData.courseID}/${cv}/quarry_ridge_${h}_landingzone.jpg`;
      }
    },
  },

  filters: {
    nan(val) {
      if (isNaN(val)) return '-';
      return val;
    },

    elevationFormat(val) {
      if (!val) return '-';
      return (val * -1).toFixed(1);
    },

    getPlayer(value) {
      switch (value) {
        case '0':
        case 0:
          return 'Player 1';
        case '1':
        case 1:
          return 'Player 2';
        case '2':
        case 2:
          return 'Player 3';
        case '3':
        case 3:
          return 'Player 4';
        default:
          return '...';
      }
    },

    pinDistanceFormat(value) {
      if (!value) return;
      return this.roundNumCeil(value / 3) ?? 0;
    },
  },

  watch: {
    canvasWidth(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.shotData?.length) {
          this.fetchData();
        }
      }
    },

    shotIDProp(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.ctx?.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
        this.fetchData();
      }
    },

    // filteredShotData(newVal, oldVal) {
    //   if (newVal.length) {
    //     setTimeout(() => {
    //       newVal.forEach((data) => {
    //         const {
    //           display_name: name = 'Player',
    //           ball_position_x: ballX,
    //           ball_position_y: ballY,
    //         } = data;
    //         const ballXCoord = ballX * this.canvas?.width;
    //         const ballYCoord = ballY * this.canvas?.height;
    //         drawPoint(this.ctx, ballXCoord, ballYCoord, name, 'yellow', 3, 35, 10, '10');
    //       });
    //     }, 1000);
    //   }
    // },

    groupedOtherPlayers(newValue, _) {
      if (this.singlePlayer) return;
      this.drawOtherPlayers(newValue);
    },

    otherPlayers(newValue, _) {
      if (this.singlePlayer) return;
      this.drawOtherPlayers(newValue);
    },
  },
};
</script>

<style scoped>
.shot-container {
  margin-top: 24px;
  margin-bottom: 24px;
  height: 100%;
  min-height: 100% !important;
}

.shot-container-mobile {
  margin-top: 0px;
  margin-bottom: 0px;
  min-height: 100% !important;
  width: 100% !important;
}

.nexus-container {
  width: 612px;
}

.std-container {
  width: 331px;
}

.theme--dark.v-card.shot-card {
  border: 1px solid var(--grey-light, #95989b);
  background-color: var(--white, #efefef) !important;
}

.info-section {
  /* background-color: var(--greenInfo, #5e973e); */
  background-color: var(--grey-lightTG, #dad9da);
}

.carry-section {
  background-color: var(--primary, #ba2127);
}

.topViewImage {
  border: 1px solid var(----grey-light, #95989b);
}

.progress-one {
  max-height: 120px;
}

canvas {
  display: block;
  position: absolute;
  top: 0;
  margin: 0 auto;
  z-index: 100;
}

canvas.nexus-canvas {
  aspect-ratio: 4/5;
}

canvas.std-canvas {
  aspect-ratio: 1/2;
}

* >>> .theme--light.v-divider {
  border-color: rgba(0, 0, 0, 0.25);
}

@media screen and (max-width: 1024px) {
  .shot-container {
    width: auto;
  }

  .nexus-container {
    width: 612px;
  }

  .std-container {
    width: 331px;
  }
}
@media screen and (max-width: 600px) {
  .shot-container {
    max-width: 331px;
  }
  .nexus-container {
    width: 360px;
  }

  .std-container {
    width: 331px;
  }
}
</style>
